import {
  AssetDto,
  CalculatePolicyQuoteOutput,
  CustomerDto,
  Insurer,
  OverrideKeyValueFields,
  PolicyDto,
  QuoteFailedErrorDto,
  QuoteConfig,
} from 'korint-sdk';
import { createContext } from 'react';
import type { PriceBreakdown } from './use-available-pricing';

export const QuoteContext = createContext<{
  policy?: OverrideKeyValueFields<
    PolicyDto,
    Record<string, string | number | boolean>,
    'customFields'
  >;
  asset?: OverrideKeyValueFields<
    AssetDto,
    Record<string, string | number | boolean>,
    'customFields'
  >;
  customer?: OverrideKeyValueFields<
    CustomerDto,
    Record<string, string | number | boolean>,
    'customFields'
  >;
  quoteConfig?: QuoteConfig;
  calculatedQuotes: {
    insurer?: Insurer;
    tier: string;
    excess: string;
    quote: CalculatePolicyQuoteOutput | null;
    breakdown?: PriceBreakdown;
    error?: QuoteFailedErrorDto;
  }[];
  isLoading?: boolean;
}>({ calculatedQuotes: [] });
